const VARIANT_CLASS = {
  "strong-buy": "bg-conviction bg-strong-buy",
  buy: "bg-conviction bg-buy",
  hold: "bg-conviction bg-hold",
  avoid: "bg-conviction bg-avoid",
  positive: "bg-positive",
  negative: "bg-negative",
  neutral: "bg-neutral",
  accent: "bg-accent",
  "mono-tag": "bg-mono",
};

const CONVICTION_LABEL_PREFIX = "Analyst conviction: ";

const isConvictionVariant = (v) =>
  v === "strong-buy" || v === "buy" || v === "hold" || v === "avoid";

const Badge = ({
  variant = "mono-tag",
  children,
  icon,
  ariaLabel,
  className = "",
}) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS["mono-tag"];
  const computedAria =
    ariaLabel ||
    (isConvictionVariant(variant)
      ? `${CONVICTION_LABEL_PREFIX}${typeof children === "string" ? children : variant}`
      : undefined);

  return (
    <span
      className={`bg-root ${variantClass} ${className}`.trim()}
      aria-label={computedAria}
    >
      <style>{`
        .bg-root {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-family: var(--font-mono);
          font-size: 12px;
          font-weight: 500;
          padding: 4px 10px;
          border-radius: var(--radius-pill);
          letter-spacing: 0.04em;
          line-height: 1.2;
          white-space: nowrap;
          border: 1px solid transparent;
          width: fit-content;
        }

        /* Conviction tier colors */
        .bg-strong-buy {
          color: var(--accent);
          background: var(--accent-soft);
          border-color: var(--accent-border);
        }
        .bg-buy {
          color: var(--accent);
          background: var(--accent-soft);
          border-color: var(--accent-border);
          opacity: 0.92;
        }
        .bg-hold {
          color: var(--neutral);
          background: var(--neutral-soft);
          border-color: rgba(251, 191, 36, 0.28);
        }
        .bg-avoid {
          color: var(--negative);
          background: var(--negative-soft);
          border-color: rgba(248, 113, 113, 0.28);
        }

        /* Semantic data colors */
        .bg-positive {
          color: var(--positive);
          background: var(--positive-soft);
          border-color: var(--accent-border);
        }
        .bg-negative {
          color: var(--negative);
          background: var(--negative-soft);
          border-color: rgba(248, 113, 113, 0.28);
        }
        .bg-neutral {
          color: var(--neutral);
          background: var(--neutral-soft);
          border-color: rgba(251, 191, 36, 0.28);
        }
        .bg-accent {
          color: var(--accent);
          background: var(--accent-soft);
          border-color: var(--accent-border);
        }

        /* Plain mono tag (default) */
        .bg-mono {
          color: var(--text-tertiary);
          background: transparent;
          border-color: var(--border-subtle);
          text-transform: uppercase;
        }
      `}</style>
      {icon && <span className="bg-icon" aria-hidden="true">{icon}</span>}
      {children}
    </span>
  );
};

export const convictionVariant = (conviction) => {
  if (!conviction) return "mono-tag";
  const normalized = conviction.toLowerCase().replace(/\s+/g, "-");
  if (normalized === "strong-buy" || normalized === "strong-buy.") return "strong-buy";
  if (normalized === "buy") return "buy";
  if (normalized === "hold") return "hold";
  if (normalized === "avoid") return "avoid";
  return "mono-tag";
};

export default Badge;
